import { render, staticRenderFns } from "./2_BusinessDetails.vue?vue&type=template&id=5bdc4703&"
import script from "./2_BusinessDetails.vue?vue&type=script&lang=js&"
export * from "./2_BusinessDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports